<!--物流系统团队介绍-->
<template>
<div class="newlist14">
  <vue-seamless-scroll :class-option="{limitMoveNum: 3,direction: 1,step: 0.6}" :data="dataTeam" class="warp">
    <li v-for="(item, index) in dataTeam" :key="index">
      <div class="img"><img :src="item.src"></div>
      <div class="right">
        <b>{{item.title}}</b>
        <div class="text">{{item.text}}</div>  
      </div>
    </li>
  </vue-seamless-scroll>
</div>

</template>

<script>
import api from '@/apis/transportation/transportation'
import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
    name: 'Example10Basic',
    components: {
      vueSeamlessScroll
    },
  data() {
    return {
      dataTeam:[],
    };
  },
  methods: {
    //获取数据
    getList(){
      api.getStar().then(res=>{
        if(res.code==10000){
          let _data = res.data.list
          let _arr = _data.map(item=>{
            return{
              id:item.id,
              title:item.name,
              src:item.picture,
              text:item.remark,
            }
          })
          this.dataTeam = _arr
        }
      })
    },   
  },
  mounted() {
    this.getList()
  },

};
</script>

<style lang="less" scoped>
.newlist14{ padding:0px 0.71rem 0.71rem; height: 100%; overflow: hidden;
  li{ height: 5.2rem; display: flex; flex-direction: row; align-items:flex-end; width: 100%; overflow: hidden; margin-top: 0.71rem;
    .img{ width:6rem; height: 100%; margin-right: .8rem; overflow:hidden; flex-shrink: 0;
      img{ width: 100%; height: 100%; display: block;}
    }
    .right{ flex: 1; height: 100%; overflow: hidden;
      b{ display: block; font-weight:400; font-size: .8rem; color: #05f8fc; margin-top:4px; margin-bottom: 12px; text-overflow:ellipsis; white-space: nowrap; overflow: hidden;}
      .text{ 
        overflow: hidden; 
        text-overflow: ellipsis; 
        font-size: 0.65rem; 
        height: 3rem; 
        line-height: 1rem;
        // display: -webkit-box;
        // -webkit-box-orient: vertical;
        // -webkit-line-clamp: 3;
      }
    }
  }
}
</style>